<template>
  <section class="item-asessment">
    <div class="card">
      <div class="card-header">
        <img
            class="user-img"
            :src="`https://redwhiteanalytics.com/${item.icon}`"
            alt=""
          />
      </div>
      <div class="card-body">
        <h5>{{ item.title }}</h5>
        <p>
          {{ item.description }}
        </p>
        <b-progress class="mb-2" height="11px" variant="primary" :value="answer[item.type]" :max="item.count_question"></b-progress>
        <span class="d-block text-center mb-3">{{ answer[item.type] }} / {{ item.count_question }} {{ $t('soal_selesai') }}</span>

        <button class="btn btn-primary btn-sm" :disabled="answer[item.type] >= item.count_question" @click="prosesAsessment(item)">{{answer[item.type] >= item.count_question ? $t('selesai_test') : $t('mulai_test') }}</button>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      item: {},
      answer : {}
    },
    methods:{
      prosesAsessment(item){
        let lang = localStorage.getItem('currentLanguage') ?  localStorage.getItem('currentLanguage') : process.env.VUE_APP_LANG;
        this.$router.push({
          name: 'ProsesAsessment',
          query: {
            lang: lang,
            type: item.type
          }
        });
      }
    }

  }
</script>

<style lang="scss">
.item-asessment{
  .btn-primary.disabled, .btn-primary:disabled{
    background: #ccc!important;
    border-color:#ccc!important; 
    color :#333;
    cursor: not-allowed;
  }
  .card-header{
    padding: 0!important;
    img{
      width: 100%;
      border-top-left-radius: 15px;
      border-top-right-radius: 15px;
      max-height: 150px;
      background-size: cover;
      object-fit: contain;
      margin: 2rem 0;
    }
  }

  .card-body{
    text-align: center;
    padding: 1.2rem 1.7rem!important;
    h3,p{
      text-align: center;
    }
    p{
      font-size: .9rem;
    }
    .progress{
      margin: 0 2rem;
      border-radius: 1rem;
      .progress-bar{
        border-radius: 1rem;
      }
    }
    .btn-primary{
      border-radius: .3rem;
      font-family: 'Rubik';
      font-size: .8rem;
      font-weight: 600!important;
    }
  }
}
</style>